import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-error" }
const _hoisted_2 = { class: "b-error__label" }
const _hoisted_3 = {
  class: "b-error__cta joy-btn joy-btn_default",
  href: "/project-proposal-summaries"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VJoyIcon, {
      name: "warning-triangle",
      color: "warning",
      size: "large"
    }),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$msg('customer.brief.loader.error')), 1),
    _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$msg('customer.brief.loader.error.cta')), 1)
  ]))
}